import { baseConf } from './base'
import type { Config } from './prod'

export const conf: Config = {
  ...baseConf,
  accountHub: {
    security: 'https://account.qagr.io/security',
  },
  api: {
    analytics: 'https://gateway.qagr.io/analytics/api',
    auth: 'https://auth.qagr.io/auth/v3',
    authV4: 'https://auth.qagr.io/auth/v4/api',
    capi: 'https://capi.qagr.io/api',
    institution: 'https://gateway.qagr.io/institution/api',
    redirect: 'https://redirect.qagr.io/redirect/way',
    subscription: 'https://subscription.qagr.io',
    dox: 'https://dox.qagr.io',
    cheetah: 'https://capi.qagr.io/api/configuration/cheetah/v1/settings',
    zoomWebinar:
      'https://applications.zoom.us/api/v1/pardot/registration/FhlbeOAHRsGyoy15OysALQ?state=VkVSU046MDAwplODttRjTeyU9UYQnSCuzDipwU4CRcD2VoUxAQFB8CScLZrF6tj6D0r9U5BfOw1JVoM',
    facadeServer: 'https://www.qagr.io',
    settingsRegistry: 'https://gateway.qagr.io/settings-registry/v1',
  },
  domains: {
    cookie: '.qagr.io',
    main: 'qagr.io',
    superhuman: 'qa-sh.io',
  },
  recaptcha: {
    salesforce: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6LeWQvcpAAAAAAFF-WISY9AJoHJ_I3z9nOX1GqI-',
    },
    got: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6LeWQvcpAAAAAAFF-WISY9AJoHJ_I3z9nOX1GqI-',
    },
    enterprise: {
      urls: {
        original: 'https://www.google.com/recaptcha/enterprise.js',
        global: 'https://www.recaptcha.net/recaptcha/enterprise.js',
      },
      siteKey: '6LdSYv0UAAAAAF5PhF0Z1rK7QiupkyRBy1ebiFc4',
    },
    visible: {
      urls: {
        original: 'https://www.google.com/recaptcha/api.js',
        global: 'https://www.recaptcha.net/recaptcha/api.js',
      },
      siteKey: '6LdytLcUAAAAACE166s-sdC7FELY1-pyo0mAO62V',
    },
    visibleEnterprise: {
      sitekey: '6LcTmlolAAAAAKcDAZQE0o-1rBJT4R2xzuz6zqaA',
    },
  },
  socialOAuth: {
    facebook: {
      clientId: '224990081190623',
    },
    google: {
      clientId: '913728339568-tjccmfojammmqs9q0kunokb507mpjqum.apps.googleusercontent.com',
    },
    apple: {
      clientId: 'io.qagr.service',
    },
  },
  support: {
    urls: {
      main: 'https://qa-grammarly.zendesk.com',
      newRequest: 'https://qa-grammarly.zendesk.com/hc/en-us/requests/new',
      signUpEmailVerification: '',
      signInEmailFailure: '',
    },
    email: 'support@grammarly.com',
  },
  tracking: {
    felog: {
      url: 'https://f-log-at.grammarly.io',
    },
    femetrics: {
      url: 'https://website.femetrics.grammarly.io/batch/import',
    },
    gnar: {
      url: 'https://gnar.qagr.io',
    },
    // only adding fullstory in prod
    fullStory: {
      host: '',
      script: '',
      orgId: '',
    },
    sprig: {
      environmentId: 'KC2yY7oykoLB',
    },
  },
  urls: {
    main: 'https://www.qagr.io',
    mainForText: 'grammarly.com',
    editor: 'https://app.qagr.io',
    editorNewDoc: 'https://app.qagr.io/ddocs/new',
    aiEditorNewDoc: 'https://coda.qagr.io/newdoc',
    demoEditor: 'https://demo.qagr.io',
    capiWs: 'wss://capi.qagr.io/freews',
    social: {
      facebook: 'https://www.facebook.com/grammarly',
      instagram: 'https://www.instagram.com/grammarly/',
      github: 'https://github.com/grammarly',
      linkedin: 'https://www.linkedin.com/company/grammarly',
      pinterest: 'https://www.pinterest.com/grammarly',
      twitter: 'https://twitter.com/grammarly',
      tumblr: 'https://grammarly.tumblr.com',
      youtube: 'https://www.youtube.com/user/theGrammarly',
      twitterEng: 'https://twitter.com/grammarlyeng',
      wikipedia: 'https://en.wikipedia.org/wiki/Grammarly',
    },
    developer: {
      home: 'https://developer.qagr.io',
    },
  },
  transcend: {
    id: '6beaafdb-ad13-4a71-bbf9-467debfba53d',
  },
}
